import { PlusCircle } from "react-feather";
import { IntegratingMessage, IntegratingTitle } from "../../../../../Constants/Constants";
import { IntegratingData } from "../../../../../Data/Messenger/Messenger";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { dynamicImage, Image } from "../../../../../Utils";
import CommonMediaHeading from "./Common/CommonMediaHeading";

const Integrating = () => {
  const { settingsActiveTab } = useAppSelector((state) => state.mainSidebar);
  return (
    <div className="setting-block">
      <div className={`block ${settingsActiveTab === "integrating" ? "open" : ""}`}>
        <CommonMediaHeading title={IntegratingTitle} />
        <ul className="integratin">
          {IntegratingData.map((item, index) => (
            <li key={index}>
              <div className="d-flex">
                <div className="media-left">
                  <a className={item.class} href={item.url} target="_blank" rel="noopener noreferrer">
                    <i className={`fa fa-${item.icon} me-2`} />
                    <h5>{item.title}</h5>
                  </a>
                </div>
                <div className="media-right">
                  <div className="profile">
                    {item.link ? (
                      <a href="https://slack.com/get-started#/" target="_blank" rel="noopener noreferrer">
                        <PlusCircle />
                      </a>
                    ) : (
                      <Image className="bg-img img-fluid" src={dynamicImage(`contact/${index + 1}.jpg`)} alt="Avatar" />
                    )}
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <CommonMediaHeading title={IntegratingTitle} text={IntegratingMessage} type="integrating" />
    </div>
  );
};

export default Integrating;
